import { useTranslation } from 'react-i18next';
import UPInput from 'components/input';
import {
  COMPANY_INTEGRATION__ENVIRONMENT_KEY,
  COMPANY_INTEGRATION__EXTERNAL_BASE_URL,
  COMPANY_INTEGRATION__EXTERNAL_DESCRIPTION,
  COMPANY_INTEGRATION__EXTERNAL_PASSWORD,
  COMPANY_INTEGRATION__EXTERNAL_TOKEN,
  COMPANY_INTEGRATION__EXTERNAL_USERNAME,
} from 'translations/constants';
import { RowContainer } from '../styles';
import { BeepleIntegrationProps } from './types';

const BeepleIntegration = (props: BeepleIntegrationProps): JSX.Element => {
  const {
    environmentKey,
    description,
    baseUrl,
    userName,
    password,
    privateKey,
    setEnvironmentKey,
    setBaseUrl,
    setUserName,
    setPassword,
    setDescription,
    setPrivateKey,
  } = props;
  const [t] = useTranslation();

  return (
    <>
      <RowContainer>
        <UPInput
          value={environmentKey}
          label={t(COMPANY_INTEGRATION__ENVIRONMENT_KEY)}
          placeholder={t(COMPANY_INTEGRATION__ENVIRONMENT_KEY)}
          helperText=""
          onChange={e => setEnvironmentKey(e.target.value)}
        />
      </RowContainer>
      <RowContainer>
        <UPInput
          value={description}
          label={t(COMPANY_INTEGRATION__EXTERNAL_DESCRIPTION)}
          placeholder={t(COMPANY_INTEGRATION__EXTERNAL_DESCRIPTION)}
          helperText=""
          onChange={e => setDescription(e.target.value)}
        />
      </RowContainer>
      <RowContainer>
        <UPInput
          value={baseUrl}
          label={t(COMPANY_INTEGRATION__EXTERNAL_BASE_URL)}
          placeholder={t(COMPANY_INTEGRATION__EXTERNAL_BASE_URL)}
          helperText=""
          onChange={e => setBaseUrl(e.target.value)}
        />
      </RowContainer>
      <RowContainer>
        <UPInput
          value={userName}
          label={t(COMPANY_INTEGRATION__EXTERNAL_USERNAME)}
          placeholder={t(COMPANY_INTEGRATION__EXTERNAL_USERNAME)}
          helperText=""
          onChange={e => setUserName(e.target.value)}
        />
      </RowContainer>
      <RowContainer>
        <UPInput
          value={password}
          label={t(COMPANY_INTEGRATION__EXTERNAL_PASSWORD)}
          placeholder={t(COMPANY_INTEGRATION__EXTERNAL_PASSWORD)}
          helperText=""
          onChange={e => setPassword(e.target.value)}
        />
      </RowContainer>
      <RowContainer>
        <UPInput
          value={privateKey}
          label={t(COMPANY_INTEGRATION__EXTERNAL_TOKEN)}
          placeholder={t(COMPANY_INTEGRATION__EXTERNAL_TOKEN)}
          helperText=""
          onChange={e => setPrivateKey(e.target.value)}
        />
      </RowContainer>
    </>
  );
};

export default BeepleIntegration;
